import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useHttpClient } from '../../../../shared/http-client';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { RouteComparisonModal } from './route-comparison-modal';
//import { ItvTabForm } from './itv-tab-form';




export const VisitasTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);
    const [refresh, setRefresh] = useState<string | null>(null);
    const [showRouteModal, setShowRouteModal] = useState<boolean>(false);
    const [routeData, setRouteData] = useState<any | null>(null);

    // Load initial data
 /*    useEffect(() => {
        if (id) {
            api(`/fleet/customer-visits/?customer=${id}`, 'GET');
        }
    }, [id]); */


    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };

    const handleViewRoutes = (visit: any) => {
        console.log('visit', visit)
        // Formatear la fecha a YYYY-MM-DD
        const date = new Date(visit.timestamp);
        const formattedDate = date.toISOString().split('T')[0];
        //const formattedDate = '2026-01-02';
        
        api(`/fleet/sales-rep-route-comparisons/?driver=${visit.driver.id}&date=${formattedDate}`, 'GET');
    };


    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('fleet/customer-visits')) {
                if (state.method === 'GET') {
                    setData(state.data)

                }
            }
            if (state.path.includes('sales-rep-route-comparisons')) {
                if (state.method === 'GET') {
                    console.log('sales-rep-route-comparisons', state.data)
                    setRouteData(state.data);
                    setShowRouteModal(true);
                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }
        }
    }, [state]);



    return (
        <>
            {showRouteModal && routeData && (
                <RouteComparisonModal
                    actualRoutes={routeData.actual_routes || []}
                    plannedRoutes={routeData.planned_routes || []}
                    onClose={() => setShowRouteModal(false)}
                />
            )}

            <div>
                <Table
                    path="/fleet/customer-visits/"
                    deletePath="/fleet/customer-visits/"
                    callBeforeDrawerClosed={handleClose}
                    noEdit={true}
                    noDelete={true}
                    withPagination
                    refresh={refresh}
                    query={`customer=${id}`}
                    customActions={(visit: any) => (
                        <>
                            <button
                                className="px-2 rounded-md text-primary text-xs"
                                onClick={() => handleViewRoutes(visit)}
                            >
                                {t('common.button.ver-rutas')}
                            </button>
                        </>
                    )}
                    headers={[
                        {
                            key: 'timestamp',
                            type: 'date',
                            label: 'common.labels.date',
                        },
                        {
                            key: 'contact_person',
                            label: 'common.form-label.persona-contacto',
                        },
                        {
                            key: 'cargo',
                            label: 'common.label.cargo',
                        },
                        {
                            key: 'email',
                            label: 'Email',
                        },
                        {
                            key: 'driver',
                            subKey: 'full_name',
                            label: 'common.label.comercial',
                        },

                    ]}
                />

            </div>


        </>

    );
};